import React, { useRef, useEffect, useState } from 'react';
import "./social-media-analytics-landing-card.scss"
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import trendUpIcon from "../../../assets/icons/trend-up-01.svg"
import SvgGraphicUtils from '../../../utilities/svg-graphic-util';

import HC_rounded from "highcharts-rounded-corners";

// Importing images for card
import post1 from "../../../assets/images/posts/1.jpg"
import post2 from "../../../assets/images/posts/2.jpg"
import post3 from "../../../assets/images/posts/3.jpg"
import post4 from "../../../assets/images/posts/4.jpg"
import post5 from "../../../assets/images/posts/5.jpg"
import post6 from "../../../assets/images/posts/6.jpg"
import post7 from "../../../assets/images/posts/7.jpg"
import post8 from "../../../assets/images/posts/8.jpg"
import useEmpBreakpoint from '../../../hooks/useEmpBreakpoint';
import { Color } from '../../../utilities/colors';

HC_rounded(Highcharts);


type AnalyMetric = {
    posts: string[]
    shares: number[]
    comments: number[]
    likes: number[]
}

interface Props {
    className?: string
}

const metricsForSmallView: AnalyMetric = {
    posts: [post1, post2, post3, post4, post5, post6, post7, post8],
    shares: [10, 9, 12, 13, 10, 8, 9, 28],
    comments: [14, 20, 23, 12, 14, 28, 22, 32],
    likes: [49, 71, 106, 88, 144, 50, 72, 110]
}
const metricsForLargeView: AnalyMetric = {
    posts: [post1, post2, post3, post4, post5, post6, post7, post8, post1, post2, post3],
    shares: [10, 9, 12, 13, 10, 8, 9, 28, 11, 18, 14],
    comments: [14, 20, 23, 12, 14, 28, 22, 32, 20, 18, 25],
    likes: [49, 71, 106, 88, 144, 50, 72, 110, 120, 96, 105]
}

const SocialMediaAnalyticsLandingCard = (props: Props) => {

    const { className } = props
    // True, if page width is below 800
    const isSmall = useEmpBreakpoint(800)

    const [metrics, setMetrics] = useState<AnalyMetric>(metricsForSmallView)

    useEffect(() => {
        if (isSmall) {
            setMetrics(metricsForSmallView)
        }
        else {
            setMetrics(metricsForLargeView)
        }
    }, [isSmall])



    const chartRef = useRef(null)
    // Highchart options
    const chartOptions = {
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        chart: {
            height: 300,
            backgroundColor: "transparent",
            type: 'column'
        },

        title: {
            useHTML: true,
            text: ""
        },
        plotOptions: {
            column: {
                // pointWidth: 25,
                stacking: 'normal',
                dataLabels: {
                    enabled: false
                }
            }
        },
        yAxis: {
            gridLineColor: '#43474E',
            tickAmount: 8,
            labels: {
                useHTML: true,
                format: "<span class='color-gray-500 text-medium'>{value}</span>"
            },
            stackLabels: {
                enabled: false
            },
            title: {
                text: ""
            },
        },
        xAxis: {
            // labels: {
            //     useHTML: true
            // },
            categories: metrics.posts,
            labels: {
                useHTML: true,
                formatter: (obj: any) => {
                    return `<img style="border-radius: 8px; height: 32px;width: 32px;object-fit: cover;" src="${obj.value}" />`;
                }
            },
        },
        series: [{
            borderRadiusTopLeft: '10%',
            borderRadiusTopRight: '10%',
            borderColor: undefined,
            shadow: {
                color: Color.PRIMARY[600],
                opacity: 0.015,
                width: 10,
            },
            color: Color.PRIMARY[600],
            type: "column",
            name: 'Likes',
            data: metrics.likes
        },
        {
            borderColor: undefined,
            color: Color.PRIMARY[500],
            shadow: {
                color: Color.PRIMARY[500],
                opacity: 0.015,
                width: 10,
            },
            type: "column",
            name: 'Comments',
            data: metrics.comments

        }, {
            borderColor: undefined,
            color: Color.PRIMARY[400],
            shadow: {
                color: Color.PRIMARY[400],
                opacity: 0.015,
                width: 10,
            },
            type: "column",
            name: 'Shares',
            data: metrics.shares

        }]

    };

    // Pie Chart options
    const pieChartOptions = {
        chart: {
            height: 200,
            backgroundColor: "transparent",
            plotShadow: false,
            type: 'pie',
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true,
                innerSize: 60,
            }
        },
        legend: {
            itemStyle: { color: "#9EA3AC", fontWeight: "500" }

        },
        series: [{
            name: 'Brands',
            colorByPoint: true,
            type: "pie",

            data: [{
                color: "#1573FF",
                name: 'Male',
                y: 80
            }, {
                color: "#5193F8",
                name: 'Female',
                y: 120
            }]
        }]
    }


    return (
        <div className={className}>
            <div className='emrg-demo-cards'>
                <div className='card-header'>
                    <h3>Publish and Analyse</h3>
                    <p className='color-gray-300'>Effortlessly schedule and track your social media blasts with our platform</p>
                </div>


                <div className='chart-section-wrapper'>
                    <div className='top-metrics-wrapper'>
                        <div className="metrics-wrapper">
                            <div style={{ width: "100%", boxSizing: "border-box" }}>
                                <div className="emp-chart-wrapper small-card">
                                    <div className='metric-icon'>
                                        <div>
                                            <img alt='Trend up icon' style={SvgGraphicUtils.hexToFilter("#7CAEFA")} src={trendUpIcon} />
                                        </div>
                                    </div>
                                    <span className='block color-gray-350 mt-2 metric-desc'>Followers (Last 30 Days)</span>
                                    <span className='block color-gray-0 mt-2 metric-text'>12,340</span>
                                </div>
                            </div>
                        </div>
                        <div className="metrics-wrapper pl-3">
                            <div style={{ width: "100%", boxSizing: "border-box" }}>
                                <div className="emp-chart-wrapper small-card">
                                    <div className='metric-icon'>
                                        <div>
                                            <img alt='Trend up icon' style={SvgGraphicUtils.hexToFilter("#7CAEFA")} src={trendUpIcon} />
                                        </div>
                                    </div>
                                    <span className='block color-gray-350 mt-2 metric-desc'>Followers (Last 30 Days)</span>
                                    <span className='block color-gray-0 mt-2 metric-text'>12,340</span>
                                </div>
                            </div>
                        </div>
                        <div className="metrics-wrapper pl-3">
                            <div style={{ width: "100%", boxSizing: "border-box" }}>
                                <div className="emp-chart-wrapper small-card">
                                    <div className='metric-icon'>
                                        <div>
                                            <img alt='Trend up icon' style={SvgGraphicUtils.hexToFilter("#7CAEFA")} src={trendUpIcon} />
                                        </div>
                                    </div>
                                    <span className='block color-gray-350 mt-2 metric-desc'>Followers (Last 30 Days)</span>
                                    <span className='block color-gray-0 mt-2 metric-text'>12,340</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='h-stack' style={{ width: "100%" }}>
                        <div className="barchart-wrapper">
                            <div className='emp-chart-wrapper stacked-chart'>
                                <span className='chart-title color-gray-0'>Create a Post</span>
                                <div className='mt-8'>
                                    <HighchartsReact
                                        ref={chartRef}
                                        highcharts={Highcharts}
                                        options={chartOptions}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="side-metrics-wrapper">
                            <div className='pl-6' style={{ width: "100%", boxSizing: "border-box" }}>
                                <div className="emp-chart-wrapper small-card">
                                    <div className='metric-icon'>
                                        <div>
                                            <img alt='Trend up icon' style={SvgGraphicUtils.hexToFilter("#7CAEFA")} src={trendUpIcon} />
                                        </div>
                                    </div>
                                    <span className='block color-gray-350 mt-2 metric-desc'>Followers (Last 30 Days)</span>
                                    <span className='block color-gray-0 mt-2 metric-text'>12,340</span>
                                </div>
                                <div className='mt-6 emp-chart-wrapper small-card'>
                                    <span className='chart-title color-gray-0'>Gender Ratio</span>
                                    <HighchartsReact
                                        ref={chartRef}
                                        highcharts={Highcharts}
                                        options={pieChartOptions}
                                        {...props}
                                    />
                                </div>
                            </div >
                        </div>

                    </div >
                </div>
            </div>
        </div >
    )
}
export default SocialMediaAnalyticsLandingCard
